import Phaser from "phaser";
import { getAudioManager } from "../systems/AudioManager.ts";
import type { GameScene } from "./GameScene.ts";

export interface PauseMenuData {
  vehicleId: string;
  stageId: string;
}

/** In-run pause overlay. All navigation goes through `GameScene` so the run is torn down
 * safely (see `GameScene.exitTo`). */
export class PauseMenuScene extends Phaser.Scene {
  constructor() {
    super("PauseMenuScene");
  }

  create(data: PauseMenuData): void {
    const { width, height } = this.scale;
    const audio = getAudioManager();
    const game = this.scene.get("GameScene") as GameScene;
    const cx = width / 2;
    const cy = height / 2;

    // Full-screen blocker so taps don't fall through to the HUD pedals underneath.
    this.add.rectangle(0, 0, width, height, 0x000000, 0.35).setOrigin(0, 0).setInteractive();
    this.add.rectangle(cx, cy + 20, 420, 420, 0x102232, 0.95).setStrokeStyle(4, 0x9bc7ff);
    this.add
      .text(cx, cy - 120, "PAUSED", {
        fontFamily: "Arial, sans-serif",
        fontSize: "38px",
        color: "#ffe27a",
        fontStyle: "bold",
      })
      .setOrigin(0.5);

    const button = (y: number, label: string, color: number, onClick: () => void): void => {
      const rect = this.add.rectangle(cx, y, 240, 52, color).setInteractive({ useHandCursor: true });
      this.add
        .text(cx, y, label, {
          fontFamily: "Arial, sans-serif",
          fontSize: "22px",
          color: "#ffffff",
          fontStyle: "bold",
        })
        .setOrigin(0.5);
      rect.on("pointerdown", () => {
        audio.playUiClick();
        onClick();
      });
    };

    button(cy - 40, "RESUME", 0x4a9a5f, () => game.resumeFromPause());
    button(cy + 30, "SETTINGS", 0x2b3a4a, () => {
      this.scene.stop();
      this.scene.launch("SettingsScene", { fromPause: data });
    });
    button(cy + 100, "RESTART", 0xe0663f, () => game.exitTo("GameScene", data));
    button(cy + 170, "GARAGE", 0x2b3a4a, () => game.exitTo("GarageScene"));
  }
}
